import { type SalonStockerHttpTypes } from "@repo/api-sdk";
import { queryKeysFactory } from "../queryKeyFactory";

const ROOT_QUERY_KEY = "sellers" as const;
export const queryKeys = {
  ...queryKeysFactory<
    typeof ROOT_QUERY_KEY,
    SalonStockerHttpTypes.StoreSellerListParams
  >(ROOT_QUERY_KEY)
};
